webpackJsonp([12],{

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      date: null,
      events: [],
      show: [],
      router: __WEBPACK_IMPORTED_MODULE_1__router_index_js__["a" /* default */],
      removed: [],
      todoCounter: 0,
      search: '',
      searchChange: false
    };
  },

  watch: {
    search: function search() {
      this.show = this.show.map(function (boolean) {
        return false;
      });
      if (this.search) {
        var found = false;
        for (var i = 0; i < this.events.length; i++) {
          var event = this.events[i];
          if (event.title.toLowerCase().includes(this.search.toLowerCase())) {
            this.show[event.date] = true;
            if (!found) {
              this.searchChange = true;
              this.date = event.date;
              found = true;
            }
          }
        }
      } else {
        this.date = null;
      }
    },
    date: function date() {
      if (!this.searchChange) {
        this.show = this.show.map(function (boolean) {
          return false;
        });
        var dates = this.events.map(function (event) {
          return event.date;
        });
        if (dates.includes(this.date)) {
          this.show[this.date] = true;
        }
      } else {
        this.searchChange = false;
      }
    }
  },
  methods: {
    pushProject: function pushProject(projectID) {
      this.$store.dispatch('Project', projectID);
      __WEBPACK_IMPORTED_MODULE_1__router_index_js__["a" /* default */].push('/project/' + projectID);
    },
    functionEvents: function functionEvents(date) {
      var dates = this.events.map(function (event) {
        return event.date;
      });
      return dates.includes(date);
    },
    colorPicker: function colorPicker(date) {
      var selectedDates = this.events.filter(function (event) {
        return event.date === date;
      });
      if (selectedDates.length > 1) {
        return 'red';
      } else {
        switch (selectedDates[0].type) {
          case 'meeting':
            return 'blue';
          case 'todo':
            return 'yellow';
        }
      }
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).collection('projects').get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var projectID = doc.data().projectID;
        __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(projectID).get().then(function (doc) {
          var projectTitle = doc.data().title;

          __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(projectID).collection('meeting').get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              if (doc.data().members.includes(_this.$store.getters.user.id)) {
                var title = doc.data().title;
                var date = doc.data().startDate;
                var time = doc.data().startTime;
                var type = 'meeting';
                var icon = '../../static/img/official_icons/event2.png';
                var id = doc.data().id;
                var event = {
                  projectID: projectID,
                  projectTitle: projectTitle,
                  title: title,
                  date: date,
                  time: time,
                  type: type,
                  icon: icon,
                  id: id
                };
                _this.events.push(event);
              }
            });
          });
          __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(projectID).collection('todo').get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              if (doc.data().members === _this.$store.getters.user.id || doc.data().creator === _this.$store.getters.user.id) {
                var title = doc.data().title;
                var date = doc.data().startDate;
                var time = doc.data().startTime;
                var type = 'todo';
                var icon = '../../static/img/official_icons/todo2.png';
                var id = doc.data().id;
                _this.todoCounter++;
                var event = {
                  projectID: projectID,
                  projectTitle: projectTitle,
                  title: title,
                  date: date,
                  time: time,
                  type: type,
                  icon: icon,
                  id: id
                };
                _this.events.push(event);
              }
            });
          });
        });
      });
    });
  }
});

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('div', {
    staticClass: "primary"
  }, [_c('v-subheader', {
    staticClass: "event",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "8ex",
      "max-height": "8ex"
    },
    attrs: {
      "src": "/static/img/official_icons/event2.png"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "event",
    staticStyle: {
      "color": "white",
      "psition": "relative",
      "bottom": "10px"
    }
  }, [_vm._v("Personal Calender\n      ")])])], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "box": "",
      "placeholder": "Search an event, project, or todo..."
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "height": "150%",
      "width": "200%",
      "events": _vm.functionEvents,
      "event-color": function (date) { return _vm.colorPicker(date); },
      "landscape": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.events), function(event) {
    return [(_vm.show[event.date]) ? _c('v-list-tile', {
      key: event.id,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          _vm.pushProject(event.projectID)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": event.icon
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(event.title)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(event.projectTitle)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(event.date)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(event.time)
      }
    })], 1)], 1) : _vm._e()]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.c12e26f54b043c171550.js